export enum generatorView {
  cardView = 'cardview',
  listView = 'listview'
}

export enum preferredEditor {
  codeEditor = 'codeEditor',
  formEditor = 'formEditor'
}

export enum editorTheme {
  vsDark = 'vs-dark',
  vsLight = 'vs-light'
}

export enum appLanguage {
  english = 'en',
  german = 'de',
  finnish = 'fi'
}

export enum tooltips {
  on = 'true',
  off = 'false'
}

export enum loggingAllowed {
  true = 'true',
  false = 'false'
}

export enum showLogInfo {
  true = 'true',
  false = 'false'
}

export enum deleteConfirmation {
  true = 'true',
  false = 'false'
}



// WEBPACK FOOTER //
// ./src/constants/profileSettings.ts